import React, { useEffect, useState } from "react";
import HomeCard from "../homePage/homeCard";
import OutlineButton from "../homePage/outlineButton";
import PromotionCard from "../shared/promotionCard";
import PromotionIcon from "../constants/assests/image/promotionIcon.png";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../reduxStore/store";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchCurrentUser } from "../models/currentUserSlice";
import { getCoupons } from "../models/couponSlice";
import LoadingIndicator from "../shared/loadingIndicator";
import Emptydata from "../shared/emptyData";
// import PromationIcon from "../constants/assests/image/promotionIcon.png";
import TransactionIcon from "../constants/assests/image/TransactionIcon.png";
import { getShofifyToken } from "../models/shopifyLoginAPI";
import LoyaltyIcon from "@mui/icons-material/EmojiEvents";
import HistoryIcon from "@mui/icons-material/History";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import InfoIcon from "@mui/icons-material/Info";
import { useAppSelector } from "../reduxStore/hooks";
import LoyaltyIcon2 from '@mui/icons-material/Loyalty';
import { useSettings } from "../../hooks/useSettings";


const HomePage: React.FC = () => {
  const [indicator, setIndicator] = useState<boolean>(false);
  const [tokenablable, setTokenAbilable] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const id = searchParams.get("id");
  const shop_domain = searchParams.get("shop_domain");


  const firstName = useSelector(
    (state: RootState) => state.currentUser.user?.first_name
  );
  const points = useSelector(
    (state: RootState) => state.currentUser.user?.points.current_points
  );
  const tierTitle = useSelector(
    (state: RootState) => state.currentUser.user?.tier?.title
  );
  const coupons = useSelector((state: RootState) => state.coupon.coupons);
  const loading = useSelector((state: RootState) => state.coupon.loading);
  const loadingTwo = useSelector(
    (state: RootState) => state.currentUser.loading
  );
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const { user, error } = useAppSelector((state) => state.currentUser);

  const fetchShopifyToken = async () => {
    setIndicator(true);
    try {
      // localStorage.clear();
      // const avilableToken = localStorage.getItem("accessToken");
      // if(avilableToken=== null){
      //   console.log("Token is null");
      //   setTokenAbilable(true);
      // }
      const token = localStorage.getItem("accessToken");
      if (!token) {
        const result = await getShofifyToken(id, email,shop_domain || "");
        if (result && result.status === 200) {
          const accessToken = result.data.data.bearer_token;
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("shop_domain", shop_domain || '');
          try {
            await dispatch(fetchCurrentUser()).unwrap();
          } catch (error) {
            localStorage.clear();
            navigate("/guest");
          }
          await dispatch(getCoupons()).unwrap();
        } else {
          localStorage.clear();
          navigate("/guest");
        }
      } else {
        try {
          await dispatch(fetchCurrentUser()).unwrap();
        } catch (error) {
          localStorage.clear();
          navigate("/guest");
        }
        await dispatch(getCoupons()).unwrap();
      }
    } catch (error) {
      console.error("Error fetching Shopify token:", error);
    } finally {
      setIndicator(false);
    }
  };

  useEffect(() => {
    setIndicator(true);

    // if (!email || !id) {
    //   console.error("Email or ID missing from query parameters");
    //   return;
    // }
    fetchShopifyToken();
  }, [email, id]);

  useEffect(() => {
    setIndicator(true);
    const fetchData = async () => {
      try {
        await dispatch(fetchCurrentUser()).unwrap();
        await dispatch(getCoupons()).unwrap();

        // setTimeout(() => {
        //   setIndicator(false);
        // }, 10000);
      } catch (error) {
        setIndicator(false); // Handle error without delay
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  const handleCouponClick = (couponId: string) => {
    navigate("/Promotionconfirm", { state: { couponId } });
  };

 

   const { settings, getSetting } = useSettings();
     const primaryColor = getSetting('primary_color', process.env.REACT_APP_PRIMARY_COLOR || '#1E3A8A');
    const hoverColor = getSetting('widget_hover_color', process.env.REACT_APP_PRIMARY_COLOR_HOVER || '#2563EB');
    const site_loyalty_page_url = getSetting('site_loyalty_page_url');

     const onClickAbout = () => {
      // const url = `${STORE_URL}/pages/loyalty`;
      window.parent.postMessage({ action: 'redirectjoin', url: site_loyalty_page_url }, '*');
      };

  return (
    <>
      {indicator ? (
        <LoadingIndicator />
      ) : (
        <div className="flex flex-col h-[100vh] w-screen overflow-x-hidden">
          {/* First Row */}
          <div className="flex flex-col flex-grow">
            {/* <div className="bg-customBgGray"> */}
              {/* <div className=""> */}
              <HomeCard
                pointAmount={points}
                userName={firstName}
                tier={tierTitle}
              />
            {/* </div> */}
            <div className="flex flex-col w-full pb-1 justify-between items-center p-4 mt-1">

              {user?.mobile === null &&
                <div className="w-full pb-3" style={{borderColor:primaryColor}}>
                  <a href="/account">
                    <OutlineButton cardName="Complete Your Profile" Icon={AccountCircleIcon} className="border-red-500"/>
                  </a>
                </div>
               } 
              <div className="w-full pb-3">
                <a href="/allcoupons">
                  <OutlineButton cardName="Redeem Points" Icon={CardGiftcardIcon} />
                </a>
              </div>
              <div className="w-full pb-3">
                <a href="/transaction">
                  <OutlineButton cardName="Point History" Icon={HistoryIcon} />
                </a>
              </div>
              <div className="w-full pb-3">
                <a href="/mycoupons">
                  <OutlineButton cardName="My Rewards" Icon={LoyaltyIcon} />
                </a>
              </div>
              <div className="w-full pb-3">
                <a href="/earnpoints">
                  <OutlineButton cardName="Earn Points" Icon={LoyaltyIcon2} />
                </a>
              </div>
              <div className="w-full pb-3">
                <a onClick={onClickAbout}>
                  <OutlineButton cardName="About Loyalty Program" Icon={InfoIcon} />
                </a>
              </div>
            </div>



          </div>

          {/* Second Row */}
          {/* <div className="bg-bright-ashe flex-grow overflow-auto">
            <div className="flex flex-row justify-between items-center p-4">
              <div className="cursor-pointer font-medium text-xs">Coupons</div>
              <a href="/allcoupons">
                <div className="cursor-pointer font-medium text-xs hover:text-blue-400">
                  See More
                </div>
              </a>
            </div>
            <div>
              {coupons ? (
                coupons.slice(0, 2).map((coupon, index) => (
                  <div
                    className="mx-5"
                    key={index}
                    onClick={() => handleCouponClick(coupon.id)}
                  >
                    <PromotionCard
                      header={coupon.title}
                      description={coupon.end_date}
                      src={PromotionIcon}
                      footerText={coupon.points}
                    />
                  </div>
                ))
              ) : (
                <Emptydata />
              )}
            </div>
          </div> */}
        </div>
      )}
    </>
  );
};

export default HomePage;
